var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"display"},[_c('ButtonOutlined',{staticClass:"mb-2",attrs:{"text":"Pong"},nativeOn:{"click":function($event){return _vm.$router.push({
            name: 'Pong'
          })}}}),_c('ButtonOutlined',{staticClass:"mb-2",attrs:{"text":"Minesweeper"},nativeOn:{"click":function($event){return _vm.$router.push({
      name: 'Minesweeper'
    })}}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }